import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";

import { ShiftReportDelay } from "@/pages/shift-report/models/ShiftReportResponse";
import { backgroundColor } from "@/utils/theme";
import { RowClassParams, RowStyle } from "ag-grid-community";
import { useTableData } from "./useTableData";

export const TableDelays = ({
	delays,
	hoveredDelayId,
	onDelayHover,
}: {
	delays: ShiftReportDelay[];
	hoveredDelayId: number | null;
	onDelayHover?: (delayId: number | null) => void;
}) => {
	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	const getRowStyle = (
		params: RowClassParams<ShiftReportDelay, any>,
	): RowStyle | undefined => {
		const delay = params.data;
		if (!delay) return undefined;

		if (delay.DelayId == hoveredDelayId)
			return { backgroundColor: backgroundColor };

		return undefined;
	};

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					height: "100%",
					width: "100%",
					"& .ag-cell": {
						fontSize: 11,
					},
				}}
			>
				<AgGridReact<ShiftReportDelay>
					rowData={delays || []}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={34}
					headerHeight={34}
					animateRows
					getRowId={(params) => String(params.data.DelayId)}
					getRowStyle={getRowStyle}
					loadingOverlayComponent={CenteredLazyLoading}
					onCellMouseOver={(e) => onDelayHover?.(e.data?.DelayId ?? null)}
					onCellMouseOut={() => onDelayHover?.(null)}
				/>
			</Paper>
		</>
	);
};
